import React from "react";
import { colors, fonts } from "./theme";
import { View, Text } from "./ui";

export function ProgressRing({ progress, size = 140, stroke = 12, color, label, sublabel }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const clamped = Math.max(0, Math.min(100, progress));
  const offset = c - (clamped / 100) * c;
  const ringColor = color ?? colors.brandPrimary;
  return (
    <View style={{ width: size, height: size, alignItems: "center", justifyContent: "center", position: "relative", flexShrink: 0 }}>
      <svg width={size} height={size}>
        <circle cx={size / 2} cy={size / 2} r={r} stroke={colors.ringTrack} strokeWidth={stroke} fill="none" />
        <circle
          cx={size / 2} cy={size / 2} r={r} stroke={ringColor} strokeWidth={stroke} fill="none"
          strokeDasharray={c} strokeDashoffset={offset} strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: "stroke-dashoffset 0.6s ease" }}
        />
      </svg>
      <View style={{ position: "absolute", alignItems: "center" }}>
        {label !== undefined && <Text style={{ fontWeight: fonts.bold, fontSize: size * 0.24, color: colors.onSurface }}>{label}</Text>}
        {sublabel !== undefined && <Text style={{ fontWeight: fonts.medium, fontSize: 12, color: colors.muted, marginTop: 2, textAlign: "center" }}>{sublabel}</Text>}
      </View>
    </View>
  );
}
